import Repository from "../../repository";

export default {
    Details: (payload) => Repository.post(`/api/ReportFires/Details`, payload),
    Totals: (payload) => Repository.post(`/api/ReportFires/Totals`, payload),
}
